export const getErrorState = (state) => state.exchange.error;
